import { useRef } from 'react';

// Provide functionality to focus on an input programatically
export const useFocus = () => {
	const htmlElRef = useRef(null);
	const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() };
	return [htmlElRef, setFocus];
}
